import { Children, createContext, useState } from 'react';
import SignIn from '../pages/auth/signin';
import { signUp } from 'aws-amplify/auth';
import { signIn } from 'aws-amplify/auth';
import { useStatStyles, useToast } from '@chakra-ui/react';
import { GenError } from '../error_toasts/error';
import { confirmSignUp } from 'aws-amplify/auth';
import { ConsoleLogger } from 'aws-amplify/utils';
import { useNavigate } from 'react-router-dom';
    import { getCurrentUser } from 'aws-amplify/auth';
    import { signOut } from 'aws-amplify/auth';
export const Globle_app_context = createContext();
export default function Globle_app_context_function({ children }) {
  let toast = useToast();
  let Auth_status = JSON.parse(localStorage.getItem('my_auth')) || null;
  let [sign_in_state, setsign_in_state] = useState();
  let [sign_up_state, setsign_up_state] = useState();
  let [sign_in_state_loading, setsign_in_state_loading] = useState(false);
  let [sign_up_state_loading, setsign_up_stateloading] = useState(false);
  let [logout_loading,setlogout_loading]=useState(false)

  let [otp_verification, setotp_verification] = useState({});

  const Navigate = useNavigate();
  let [signUp_state, setsignUp_state] = useState('sign_up');

  function hendleSign_inForm_input(e) {
    const { name, value } = e?.target;
    setsign_in_state((prev) => ({ ...prev, [name]: value }));
  }

  function hendleSign_upForm_input(e) {
    const { name, value } = e?.target;
    console.log(name, value, e);
    setsign_up_state((prev) => ({ ...prev, [name]: value }));
  }

  async function user_signup(e) {
    e.preventDefault();
    setsign_up_stateloading(true);
    try {
      const { isSignUpComplete, userId, nextStep } = await signUp({
        username: sign_up_state?.username || '',
        password: sign_up_state?.password || '',
        options: {
          userAttributes: {
            name: sign_up_state?.name || '',
          },
        },
      });
      if (nextStep['signUpStep'] == 'CONFIRM_SIGN_UP') {
        setsign_up_stateloading(false);
        setsignUp_state('otpVerification');
      } else {
        throw 'Somthing went wrong';
      }
    } catch (err) {
      setsign_up_stateloading(false);
      if (err == 'UsernameExistsException: User already exists') {
        toast(GenError('User already exists'));
      } else {
        toast(GenError('Somthing went wrong'));
      }
    }
  }

  async function GetCurrent_user(){

    const { name,username, userId, signInDetails } = await getCurrentUser();
    console.log('username', name);
    console.log('user id', userId);
    console.log('sign-in details', signInDetails);
  }

  async function user_sign_in(e) {
    e.preventDefault();
    setsign_in_state_loading(true);
    try {
      let result = await signIn({
        username: sign_in_state?.username || '',
        password: sign_in_state?.password || '',
      });
      if (result?.isSignedIn) {
        localStorage.setItem('my_auth', true);
        GetCurrent_user()
        setsign_in_state_loading(false);
        Navigate('/home');
      } else {
        throw 'Somthing went wrong';
      }
    } catch (err) {
      setsign_in_state_loading(false);
      if (err == 'NotAuthorizedException: Incorrect username or password.') {
        toast(GenError('Incorrect username or password'));
      } else {
        toast(GenError('Somthing went wrong'));
      }
    }
  }

  async function hendleOtp_verification(e) {
    setsign_up_stateloading(true);
    try {
      const { isSignUpComplete, nextStep } = await confirmSignUp({
        username: sign_up_state?.username || '',
        confirmationCode: otp_verification || '',
      });
      if (isSignUpComplete) {
        setsign_up_stateloading(false);
        Navigate('/signin');
      } else {
        throw 'somthing went wrong';
      }
    } catch (err) {
      setsign_up_stateloading(false);
      toast(GenError('Somthing went wrong'));
    }
  }


  // sign_out

  async function SiginOut(){
    setlogout_loading(true)
    try{
      await signOut();
      Navigate('/signin');
      localStorage.clear()
      setlogout_loading(false)
    }
    catch(err){
      setlogout_loading(false)
    }
  } 





  // if (Auth_status) {
  return (
    <Globle_app_context.Provider
      value={{
        Auth_status,
        sign_in_state,
        sign_up_state,
        hendleSign_inForm_input,
        hendleSign_upForm_input,
        user_signup,
        user_sign_in,
        signUp_state,
        setotp_verification,
        hendleOtp_verification,
        sign_in_state_loading,
        sign_up_state_loading,
        SiginOut,
        logout_loading,
      }}
    >
      {children}
    </Globle_app_context.Provider>
  );
  // } else {
  //   return (
  //     <Globle_app_context.Provider value={{ Auth_stats,
  //         sign_in_state,
  //         sign_up_state,
  //         hendleSign_inForm_input,
  //         hendleSign_upForm_input,
  //         user_signup,
  //         user_sign_in,
  //         signUp_state,       setotp_verification,
  //      hendleOtp_verification }}>
  //       {<SignIn />}
  //     </Globle_app_context.Provider>
  //   );
  // }
}
